// ---------------------------------------------------------------------------
// พจนานุกรมคำที่ใช้ซ้ำทั่วระบบ (UI chrome)
// ข้อความเฉพาะหน้าใช้ helper tx("ไทย", "English") ได้เลย ไม่ต้องมาใส่ที่นี่
// ---------------------------------------------------------------------------

export const DICTIONARY = {
  th: {
    "app.name": "LucidCRM",
    "app.tagline": "ระบบบริหารธุรกิจครบวงจร",

    "action.save": "บันทึก",
    "action.cancel": "ยกเลิก",
    "action.confirm": "ยืนยัน",
    "action.create": "สร้างใหม่",
    "action.edit": "แก้ไข",
    "action.delete": "ลบ",
    "action.close": "ปิด",
    "action.search": "ค้นหา",
    "action.filter": "ตัวกรอง",
    "action.export": "ส่งออก Excel",
    "action.back": "ย้อนกลับ",
    "action.next": "ถัดไป",
    "action.view": "ดูรายละเอียด",
    "action.pay": "ชำระเงิน",
    "action.reset": "รีเซ็ตข้อมูลตัวอย่าง",
    "action.logout": "ออกจากระบบ",
    "action.login": "เข้าสู่ระบบ",
    "action.register": "สมัครสมาชิก",
    "action.upload": "อัปโหลด",
    "action.download": "ดาวน์โหลด",
    "action.send": "ส่ง",
    "action.approve": "อนุมัติ",
    "action.reject": "ปฏิเสธ",
    "action.assign": "มอบหมาย",
    "action.print": "พิมพ์",

    "common.all": "ทั้งหมด",
    "common.status": "สถานะ",
    "common.total": "รวม",
    "common.amount": "จำนวนเงิน",
    "common.date": "วันที่",
    "common.time": "เวลา",
    "common.name": "ชื่อ",
    "common.phone": "เบอร์โทรศัพท์",
    "common.email": "อีเมล",
    "common.note": "หมายเหตุ",
    "common.branch": "สาขา",
    "common.staff": "พนักงาน",
    "common.customer": "ลูกค้า",
    "common.loading": "กำลังโหลดข้อมูล...",
    "common.empty": "ยังไม่มีข้อมูล",
    "common.rowsPerPage": "แถวต่อหน้า",
    "common.of": "จาก",
    "common.today": "วันนี้",
    "common.week": "สัปดาห์",
    "common.month": "เดือน",
    "common.day": "วัน",
    "common.quantity": "จำนวน",
    "common.price": "ราคา",
    "common.discount": "ส่วนลด",
    "common.net": "ราคาสุทธิ",
    "common.required": "จำเป็นต้องกรอก",
    "common.demo": "ข้อมูลตัวอย่าง",

    "status.draft": "ร่าง",
    "status.pending": "รอดำเนินการ",
    "status.paid": "ชำระแล้ว",
    "status.unpaid": "ยังไม่ชำระ",
    "status.overdue": "เกินกำหนด",
    "status.success": "สำเร็จ",
    "status.failed": "ไม่สำเร็จ",
    "status.cancelled": "ยกเลิก",
    "status.active": "ใช้งาน",
    "status.inactive": "ปิดใช้งาน",
    "status.confirmed": "ยืนยันแล้ว",
    "status.completed": "เสร็จสิ้น",
    "status.noshow": "ไม่มาตามนัด",
    "status.available": "ว่าง",
    "status.busy": "ไม่ว่าง",
    "status.maintenance": "ซ่อมบำรุง",

    "auth.loginTitle": "เข้าสู่ระบบ",
    "auth.registerTitle": "สมัครใช้งาน",
    "auth.forgotTitle": "ลืมรหัสผ่าน",
    "auth.password": "รหัสผ่าน",
    "auth.confirmPassword": "ยืนยันรหัสผ่าน",
    "auth.forgot": "ลืมรหัสผ่าน?",
    "auth.noAccount": "ยังไม่มีบัญชี?",
    "auth.hasAccount": "มีบัญชีอยู่แล้ว?",
    "auth.loginAs": "เข้าใช้งานในฐานะ",
    "auth.admin": "เจ้าของธุรกิจ / พนักงาน",
    "auth.customer": "ลูกค้า",

    "nav.overview": "ภาพรวม",
    "nav.settings": "ตั้งค่า",
    "nav.switchBranch": "เปลี่ยนสาขา",
    "nav.switchOrg": "เปลี่ยนธุรกิจ",
    "nav.language": "ภาษา",
  },

  en: {
    "app.name": "LucidCRM",
    "app.tagline": "All-in-one business operating system",

    "action.save": "Save",
    "action.cancel": "Cancel",
    "action.confirm": "Confirm",
    "action.create": "Create",
    "action.edit": "Edit",
    "action.delete": "Delete",
    "action.close": "Close",
    "action.search": "Search",
    "action.filter": "Filter",
    "action.export": "Export Excel",
    "action.back": "Back",
    "action.next": "Next",
    "action.view": "View",
    "action.pay": "Pay",
    "action.reset": "Reset demo data",
    "action.logout": "Log out",
    "action.login": "Log in",
    "action.register": "Sign up",
    "action.upload": "Upload",
    "action.download": "Download",
    "action.send": "Send",
    "action.approve": "Approve",
    "action.reject": "Reject",
    "action.assign": "Assign",
    "action.print": "Print",

    "common.all": "All",
    "common.status": "Status",
    "common.total": "Total",
    "common.amount": "Amount",
    "common.date": "Date",
    "common.time": "Time",
    "common.name": "Name",
    "common.phone": "Phone",
    "common.email": "Email",
    "common.note": "Note",
    "common.branch": "Branch",
    "common.staff": "Staff",
    "common.customer": "Customer",
    "common.loading": "Loading...",
    "common.empty": "No data yet",
    "common.rowsPerPage": "Rows per page",
    "common.of": "of",
    "common.today": "Today",
    "common.week": "Week",
    "common.month": "Month",
    "common.day": "Day",
    "common.quantity": "Qty",
    "common.price": "Price",
    "common.discount": "Discount",
    "common.net": "Net total",
    "common.required": "Required",
    "common.demo": "Demo data",

    "status.draft": "Draft",
    "status.pending": "Pending",
    "status.paid": "Paid",
    "status.unpaid": "Unpaid",
    "status.overdue": "Overdue",
    "status.success": "Success",
    "status.failed": "Failed",
    "status.cancelled": "Cancelled",
    "status.active": "Active",
    "status.inactive": "Inactive",
    "status.confirmed": "Confirmed",
    "status.completed": "Completed",
    "status.noshow": "No show",
    "status.available": "Available",
    "status.busy": "In use",
    "status.maintenance": "Maintenance",

    "auth.loginTitle": "Log in",
    "auth.registerTitle": "Create account",
    "auth.forgotTitle": "Forgot password",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm password",
    "auth.forgot": "Forgot password?",
    "auth.noAccount": "No account yet?",
    "auth.hasAccount": "Already have an account?",
    "auth.loginAs": "Log in as",
    "auth.admin": "Business owner / Staff",
    "auth.customer": "Customer",

    "nav.overview": "Overview",
    "nav.settings": "Settings",
    "nav.switchBranch": "Switch branch",
    "nav.switchOrg": "Switch business",
    "nav.language": "Language",
  },
};
